export const getSettingsList = state => state.settings.settingsList;
export const getLoadingStatus = state => state.settings.loading;
export const getSavingStatus = state => state.settings.saving;
export const getErrorStatus = state => state.settings.error;
